import { createSelector } from 'reselect'

import { selectFinSobState } from './selectFinSobState'

export const selectIsFinSobLoading = createSelector(
  [selectFinSobState],
  ({
    isApplicableSwitcherLoading,
    isCategoryPlanningDataLoading,
    isPlanningFactorsLoading,
    isPlanningSettingsLoading,
    isCategoryPlanningApplyingChangesLoading,
    isPlanningDataLoading,
    isPartnerFlagsLoading,
  }) => {
    return (
      isApplicableSwitcherLoading ||
      isCategoryPlanningDataLoading ||
      isPlanningFactorsLoading ||
      isPlanningSettingsLoading ||
      isCategoryPlanningApplyingChangesLoading ||
      isPlanningDataLoading ||
      isPartnerFlagsLoading
    )
  }
)
